window.addEventListener("DOMContentLoaded", function () {
    let typingTimer;
    const doneTypingInterval= 500;
    const panelRoadtrip = document.getElementById('panel-roadtrip');

    //on keyup, start the countdown
    panelRoadtrip.addEventListener("keyup", function(e){
        const target = e.target;

        if(target.classList.contains('step-input')) {
            if(typingTimer){
                clearTimeout(typingTimer);
                typingTimer = null;
            }
            typingTimer = setTimeout(doneTyping, doneTypingInterval, target);
        }
    });

    //on keydown, clear the countdown
    panelRoadtrip.addEventListener("keydown", function(e){
        const target = e.target;
        if(target.classList.contains('step-input')) {
            if (typingTimer) {
                clearTimeout(typingTimer);
                typingTimer = null;
            }
        }
    });

    //user is "finished typing," do something
    function doneTyping (target) {
        const search = target.value;
        const resultContainer = target.nextElementSibling;
        const parent = resultContainer.parentNode;

        if (resultContainer.hasChildNodes()) {
            resultContainer.innerHTML = "";
        }

        // endpoint : mapbox.places or mapbox.places-permanent (permanent should not be used)
        window.mapboxGetGeocodingCoordinatesByText(search, 5)
            .then(res => res.json())
            .then(data => {
                data.features.forEach((feature) => {
                    const divResult = document.createElement('div');
                    divResult.className = 'geocoding-result';
                    divResult.setAttribute('coordinates', feature.geometry.coordinates.toString())
                    divResult.setAttribute('title', feature.place_name)
                    const span = document.createElement('span');
                    span.append(feature.place_name)
                    divResult.append(span)
                    resultContainer.append(divResult)
                });

                resultContainer.classList.remove('hidden');
            });
    }

    panelRoadtrip.addEventListener("click", function(e){
        const target = e.target.closest('.geocoding-result');
        if(target) {
            const parent = target.parentNode;
            const input = parent.previousElementSibling;
            input.value = target.querySelector('span').innerHTML;
            input.setAttribute('coordinates', target.getAttribute('coordinates'));
            parent.innerHTML = '';
            parent.classList.add('hidden');
            window.updateRoadtripStorage();
            window.addWaypointsToMapbox();
        } else {
            document.querySelector(".mapbox-autocomplete-result:not(.hidden)")?.classList.add('hidden')
        }
    });
});
